import { DiscussionEntityRef, DiscussionMessage, DiscussionPage, DiscussionRealtimeEvent, SendDiscussionMessageInput } from '../domain/types';
import { DiscussionRepository, DiscussionRealtimeTransport } from './ports';

export interface DiscussionService {
  load(ref: DiscussionEntityRef, cursor?: string, take?: number): Promise<DiscussionPage>;
  send(ref: DiscussionEntityRef, input: SendDiscussionMessageInput): Promise<DiscussionMessage>;
  connectLive(): Promise<void>;
  disconnectLive(): Promise<void>;
  subscribe(ref: DiscussionEntityRef): Promise<void>;
  unsubscribe(ref: DiscussionEntityRef): Promise<void>;
  onEvent(handler: (event: DiscussionRealtimeEvent) => void): () => void;
}

export const createDiscussionService = (
  repository: DiscussionRepository,
  realtime?: DiscussionRealtimeTransport,
): DiscussionService => ({
  load: (ref, cursor, take) => repository.getMessages(ref, cursor, take),
  send: (ref, input) => repository.sendMessage(ref, input),
  connectLive: async () => {
    if (!realtime) {
      return;
    }
    await realtime.connect();
  },
  disconnectLive: async () => {
    if (!realtime) {
      return;
    }
    await realtime.disconnect();
  },
  subscribe: async (ref) => {
    if (!realtime) {
      return;
    }
    await realtime.join(ref);
  },
  unsubscribe: async (ref) => {
    if (!realtime) {
      return;
    }
    await realtime.leave(ref);
  },
  onEvent: (handler) => {
    if (!realtime) {
      return () => undefined;
    }
    return realtime.onEvent(handler);
  },
});
